export const MDP_ACCESS_REQUEST_URL = 'https://gsd.dhl.com/forms/3566'

// Accept urls
export const MDP_ECOMMERCE_ACCEPT_URL_NL = 'https://accept.dhlecommerce.nl'
export const MDP_ECOMMERCE_ACCEPT_URL_BE = 'https://accept.dhlecommerce.be'
export const MDP_ECOMMERCE_ACCEPT_URL_ECONNECT = 'https://econnect-accept.dhlecommerce.eu'
export const MDP_ECOMMERCE_ACCEPT_URL_PPL_CZ = 'https://accept.my.ppl.cz'

// Production urls
export const MDP_ECOMMERCE_PROD_URL_NL = 'https://my.dhlecommerce.nl'
export const MDP_ECOMMERCE_PROD_URL_BE = 'https://my.dhlecommerce.be'
export const MDP_ECOMMERCE_PROD_URL_ECONNECT = 'https://econnect.dhlecommerce.eu'
export const MDP_ECOMMERCE_PROD_URL_PPL_CZ = 'https://my.ppl.cz'

// Admin urls
export const MDP_ADMIN_ECOMMERCE_ACCEPT_URL = 'https://admin-accept.dhlecommerce.nl'
export const MDP_ADMIN_ECOMMERCE_PROD_URL = 'https://admin.dhlecommerce.nl'

// Deprecated admin urls
export const MDP_ADMIN_PARCEL_ACCEPT_URL = 'https://admin-accept.dhlparcel.nl'
export const MDP_ADMIN_PARCEL_PROD_URL = 'https://admin.dhlparcel.nl'
